(function () {
  'use strict';
  const root=document.querySelector('[data-beginner-quiz]');
  if(!root || !window.DACBeginnerQuiz || root.dataset.quizInitialized) return;
  root.dataset.quizInitialized='true';
  const $=s=>root.querySelector(s), copy=JSON.parse($('[data-quiz-copy]').textContent), form=$('[data-form]');
  const currency=root.dataset.currency,country=root.dataset.country,language=root.dataset.language, answers={art:[],shape:'any'};
  let step=0, catalogPromise=null, renderToken=0, alternateFormats=false;

  const recordedAnswers=new Map();
  let quizStarted=false, recordedResults='';
  function trackQuiz(name, details={}, completion=false){
    const payload={quiz_id:'dac-project-finder',quiz_version:'1',country,currency,...details};
    const privacy=window.Shopify?.customerPrivacy;
    try{
      if(privacy?.analyticsProcessingAllowed()){
        try{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'dac_'+name,...payload});}catch(_){}
        try{window.Shopify?.analytics?.publish('diamond_art_club:'+name,payload)?.catch?.(()=>{});}catch(_){}
      }
    }catch(_){}
    try{
      if(completion&&privacy?.marketingAllowed()){
        window._learnq=window._learnq||[];
        window._learnq.push(['track','Completed Project Quiz',payload]);
      }
    }catch(_){}
  }
  function startQuiz(){
    if(!quizStarted){quizStarted=true;trackQuiz('quiz_started');}
  }

  const parse=s=>new DOMParser().parseFromString(s,'text/html');
  const chosen=name=>form.querySelector('input[name="'+name+'"]:checked')?.value;
  const question=()=> step===4 && answers.experience==='regular' && answers.format!=='mini' ? 'shape' : ['experience','format','art','budget','help'][step];
  function endpoint(path,section){
    const u=new URL(path,location.origin);
    if(u.origin!==location.origin) throw new Error('origin');
    u.searchParams.set('section_id',section);
    u.searchParams.set('currency',currency);
    u.searchParams.delete('view');
    // The initial page navigation already established Shopify's preview-theme cookie.
    return u;
  }
  async function getHTML(url,options={}){
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),12000);
    try{const response=await fetch(url,{...options,credentials:'same-origin',signal:controller.signal});if(!response.ok)throw new Error('network');return parse(await response.text());}
    finally{clearTimeout(timer);}
  }
  async function loadCatalog(){
    let url=endpoint(root.dataset.catalogUrl,'quiz-beginner-catalog'), products=[], pages=0, restored=false;
    url.searchParams.set('filter.v.availability','1');
    const visited=new Set();
    while(url){
      if(visited.has(url.href)||++pages>20)throw new Error('catalog-incomplete');
      visited.add(url.href);
      let doc=await getHTML(url), wrapper=doc.querySelector('[data-quiz-catalog]');
      if(!wrapper)throw new Error('catalog');
      if(wrapper.dataset.currency!==currency && !restored){
        // Repair stale cart-currency state through the existing native localization form.
        // Never override a country/currency the visitor changed after starting the quiz.
        if(window.Shopify.country!==country || window.Shopify.currency.active!==currency)throw new Error('currency');
        const nativeForm=[...document.forms].find(f=>{const a=new URL(f.action);return a.origin===location.origin && a.pathname.endsWith('/localization');});
        if(!nativeForm)throw new Error('currency');
        restored=true;
        const body=new FormData(nativeForm);
        body.set('country_code',country);body.set('language_code',language);body.set('return_to',url.pathname+url.search);
        doc=await getHTML(new URL(nativeForm.action),{method:'POST',body});wrapper=doc.querySelector('[data-quiz-catalog]');
      }
      if(!wrapper || wrapper.dataset.currency!==currency)throw new Error('currency');
      products.push(...Array.from(wrapper.querySelectorAll('[data-quiz-candidate]'),e=>JSON.parse(e.textContent)));
      url=wrapper.dataset.next?endpoint(wrapper.dataset.next,'quiz-beginner-catalog'):null;
    }
    return products;
  }
  function catalog(){
    if(!catalogPromise) catalogPromise=loadCatalog().catch(error=>{catalogPromise=null;throw error;});
    return catalogPromise;
  }

  function showStep(){
    renderToken++;
    $('[data-intro]').hidden=true;$('[data-results]').hidden=true;form.hidden=false;
    for(const field of form.querySelectorAll('[data-question]'))field.hidden=field.dataset.question!==question();
    const text=copy.step.replace('[step]',String(step+1));$('[data-step-label]').textContent=text;
    $('progress').value=step+1;$('progress').setAttribute('aria-label',text);
    $('[data-next]').textContent=step===4?copy.finish:copy.next;$('[data-form-error]').textContent='';
    $('[data-format-any-title]').textContent=copy[answers.experience==='regular'?'format_any_regular_title':'format_any_beginner_title'];
    $('[data-format-any-description]').textContent=copy[answers.experience==='regular'?'format_any_regular_description':'format_any_beginner_description'];
    $('[data-mini-shape-note]').hidden=answers.format!=='mini';
    $('[data-help-shape-title]').textContent=copy[answers.format==='mini'?'help_mini_shape_title':'help_shape_title'];
    const legend=form.querySelector('[data-question="'+question()+'"] legend');legend.focus({preventScroll:true});
    root.scrollIntoView({block:'start',behavior:'instant'});
  }
  function saveStep(){
    const key=question(), values=[...form.querySelectorAll('input[name="'+key+'"]:checked')].map(e=>e.value);
    if(!values.length){$('[data-form-error]').textContent=copy.choose;return false;}
    if(key==='art'&&values.length>2){$('[data-form-error]').textContent=copy.choose_two;return false;}
    answers[key]=key==='art'?values:values[0];
    if(key==='experience'&&answers.experience!=='regular')answers.shape='any';
    if(key==='format'&&answers.format==='mini'){
      answers.shape='any';
      form.querySelector('input[name="shape"][value="any"]').checked=true;
    }
    if(key==='budget'){
      const input=$('[name="maximum"]'),amount=Number(input.value);
      if(answers.budget==='maximum'&&(!input.value||!Number.isFinite(amount)||amount<=0||!input.validity.valid)){
        input.setAttribute('aria-invalid','true');$('[data-form-error]').textContent=copy.limit_error;input.focus();return false;
      }
      input.removeAttribute('aria-invalid');answers.maximum=answers.budget==='maximum'?Math.round(amount*100):null;
    }
    const answer=key==='budget'?{preference:answers.budget,maximum:answers.maximum}:answers[key];
    const fingerprint=JSON.stringify(answer);
    if(recordedAnswers.get(key)!==fingerprint){
      recordedAnswers.set(key,fingerprint);
      trackQuiz('quiz_answered',{question:key,answer,step:step+1});
    }
    return true;
  }
  function textFor(name,value){return form.querySelector('input[name="'+name+'"][value="'+value+'"]')?.closest('label')?.querySelector('strong')?.textContent||'';}
  function explain(entry){
    const p=entry.product,lines=[copy[p.format==='canvas'&&!p.starter?'reason_canvas_all':'reason_'+p.format]];
    if(entry.styleMatches.length)lines.push(copy.reason_style.replace('[style]',entry.styleMatches.map(s=>textFor('art',s)).join(', ')));
    if(answers.budget==='maximum')lines.push(copy.reason_budget);
    return lines.join(' ');
  }
  function initializeWishlist(token){
    window.SwymCallbacks=window.SwymCallbacks||[];
    window.SwymCallbacks.push(swat=>{
      if(token===renderToken)swat.initializeActionButtons('[data-beginner-quiz] [data-grid]', '.swym-button:not(.swym-loaded)');
    });
  }
  async function showResults(){
    const token=++renderToken, results=$('[data-results]'), grid=$('[data-grid]');
    form.hidden=true;$('[data-intro]').hidden=true;results.hidden=false;results.setAttribute('aria-busy','true');
    grid.replaceChildren();grid.dataset.count='0';$('[data-price-note]').hidden=true;$('[data-message]').textContent=copy.loading_help;$('[data-results-title]').textContent=copy.loading;
    $('[data-results-copy]').textContent='';$('[data-summary]').textContent='';$('[data-guidance]').hidden=true;
    $('[data-alternates]').hidden=true;$('[data-retry]').hidden=true;
    $('[data-results-title]').focus({preventScroll:true});root.scrollIntoView({block:'start',behavior:'instant'});
    try{
      const products=await catalog();
      if(token!==renderToken)return;
      const ranked=window.DACBeginnerQuiz.rank(products,answers,currency,alternateFormats);
      // Native Shopify product cards supply the same prices, badges, art and actions as collections.
      const cards=await Promise.all(ranked.items.map(async entry=>{
        const doc=await getHTML(endpoint(entry.product.url,'quiz-beginner-card'));
        const card=doc.querySelector('[data-quiz-card]'),data=card?.querySelector('[data-quiz-candidate]');
        if(!data)return null;
        const fresh=JSON.parse(data.textContent);
        if(fresh.id!==entry.product.id||fresh.variant!==entry.product.variant||!window.DACBeginnerQuiz.hardMatch(fresh,answers,currency))return null;
        const freshEntry=window.DACBeginnerQuiz.rank([fresh],answers,currency,alternateFormats).items[0];
        if(!freshEntry)return null;
        const pick=document.createElement('div');pick.className='bq-pick';pick.dataset.productId=String(fresh.id);pick.dataset.variantId=String(fresh.variant);
        const notes=document.createElement('div');notes.className='bq-match-notes';
        const why=document.createElement('p');why.className='bq-why';why.textContent=explain(freshEntry);notes.append(why);
        if(fresh.shippingMessage){const shipping=document.createElement('p');shipping.className='bq-shipping';shipping.textContent=fresh.shippingMessage;notes.append(shipping);}
        data.remove();pick.append(document.importNode(card,true),notes);return pick;
      }));
      if(token!==renderToken)return;
      const usable=cards.filter(Boolean);grid.replaceChildren(...usable);grid.dataset.count=String(usable.length);
      if(usable.length)initializeWishlist(token);
      $('[data-results-title]').textContent=usable.length===1?copy.one_result:usable.length?copy.results:copy.empty;
      $('[data-results-copy]').textContent=usable.length?(window.DACBeginnerQuiz.catalogScope(answers)==='all'?copy.results_copy_all:copy.results_copy):copy.empty_copy;
      if(!usable.length&&!alternateFormats&&answers.format==='mini'){
        const miniAvailable=products.some(product=>product.format==='mini');
        $('[data-results-title]').textContent=copy[miniAvailable?'empty_mini_matches':'empty_mini'];
        $('[data-results-copy]').textContent=copy[miniAvailable?'empty_mini_matches_copy':'empty_mini_copy'];
      }
      const notes=[];
      if(ranked.styleFallback)notes.push(copy.style_fallback);
      if(alternateFormats)notes.push(copy.other_formats_note);
      if(usable.length<ranked.items.length){notes.push(copy.changed);$('[data-retry]').hidden=false;catalogPromise=null;}
      $('[data-price-note]').textContent=copy.note_price.replace('[currency]',currency);$('[data-price-note]').hidden=!usable.length;
      $('[data-message]').textContent=notes.join(' ');
      $('[data-alternates]').hidden=alternateFormats||!ranked.otherFormatsAvailable||usable.length>0;
      const summary=[textFor('format',answers.format),...(answers.art||[]).map(s=>textFor('art',s))];
      if(answers.shape!=='any')summary.push(copy['shape_'+answers.shape]);
      if(answers.budget==='maximum')summary.push(new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(answers.maximum/100));
      $('[data-summary]').textContent=copy.your_choices+': '+summary.filter(Boolean).join(' · ');
      const guidance=answers.help==='shape'&&answers.format==='mini'&&!alternateFormats?'help_mini_shape':answers.experience==='regular'&&answers.format!=='mini'?'experienced_help':'help_'+(answers.help||'ready');
      $('[data-guidance-copy]').textContent=copy[guidance];$('[data-guidance]').hidden=false;
      const recommendationIds=usable.map(p=>({product_id:p.dataset.productId,variant_id:p.dataset.variantId}));
      const resultKey=JSON.stringify({answers,recommendationIds,alternateFormats});
      if(resultKey!==recordedResults){
        recordedResults=resultKey;
        trackQuiz(usable.length?'quiz_completed':'quiz_no_matches',{answers:{...answers,art:[...answers.art]},recommendations:recommendationIds,result_count:usable.length,alternative_formats:alternateFormats},usable.length>0);
      }
    }catch(error){
      if(token!==renderToken)return;
      catalogPromise=null;trackQuiz('quiz_error',{reason:error.message==='currency'?'currency':'catalog'});$('[data-results-title]').textContent=copy.results;
      $('[data-message]').textContent=error.message==='currency'?copy.currency_error:copy.error;$('[data-retry]').hidden=false;
    }finally{if(token===renderToken)results.removeAttribute('aria-busy');}
  }
  $('[data-start]').addEventListener('click',()=>{startQuiz();step=0;showStep();});
  form.addEventListener('submit',event=>{event.preventDefault();if(!saveStep())return;if(step===4){alternateFormats=false;showResults();}else{if(step===1)catalog().catch(()=>{});step++;showStep();}});
  $('[data-back]').addEventListener('click',()=>{if(step>0){step--;showStep();}else{form.hidden=true;$('[data-intro]').hidden=false;$('[data-start]').focus();}});
  form.addEventListener('change',event=>{
    const input=event.target;
    if(input.name==='art'&&input.checked){
      const checked=[...form.querySelectorAll('input[name="art"]:checked')];
      if(input.value==='any')checked.forEach(e=>{if(e!==input)e.checked=false;});
      else{form.querySelector('input[name="art"][value="any"]').checked=false;
        if(checked.filter(e=>e.value!=='any').length>2){input.checked=false;$('[data-form-error]').textContent=copy.choose_two;return;}}
    }
    if(input.name==='budget'){const active=chosen('budget')==='maximum';$('.bq-maximum').hidden=!active;$('[name="maximum"]').disabled=!active;}
    $('[data-form-error]').textContent='';
  });
  $('[data-edit]').addEventListener('click',()=>{step=0;showStep();});
  $('[data-restart]').addEventListener('click',()=>{quizStarted=false;recordedResults='';recordedAnswers.clear();startQuiz();form.reset();Object.keys(answers).forEach(k=>delete answers[k]);Object.assign(answers,{art:[],shape:'any'});$('.bq-maximum').hidden=true;$('[name="maximum"]').disabled=true;catalogPromise=null;step=0;showStep();});
  $('[data-alternates]').addEventListener('click',()=>{alternateFormats=true;showResults();});
  $('[data-grid]').addEventListener('click',event=>{
    const link=event.target.closest('a[href]'),pick=link?.closest('.bq-pick');
    if(pick)trackQuiz('quiz_product_clicked',{product_id:pick.dataset.productId,variant_id:pick.dataset.variantId});
  });
  $('[data-retry]').addEventListener('click',()=>{catalogPromise=null;showResults();});
})();
